import { useState } from 'react'
import { motion, AnimatePresence } from 'motion/react'
import dynamic from 'next/dynamic'

const Player = dynamic(
  async () => {
    const ReactLottie = await import('@lottiefiles/react-lottie-player')
    return ReactLottie.Player
  },
  { ssr: false }
)

export const ProductDetails = ({
  description,
  care,
  sustainability = [],
  sizing,
  openSizing,
}: {
  description: any
  care: any
  sizing: string
  sustainability: any
  openSizing: any
}) => {
  const [activeTab, setActiveTab] = useState('detail')
  const [height, setHeight] = useState(0)

  return (
    <div>
      <div>
        <div className="flex gap-28 pb-14 text-11 uppercase text-darkGray">
          <button
            onClick={() => setActiveTab('detail')}
            className={`uppercase transition-opacity duration-300 ${
              activeTab === 'detail'
                ? 'opacity-100'
                : 'opacity-50 md:hover:opacity-75'
            }`}
          >
            Detail
          </button>
          <button
            onClick={() => setActiveTab('care')}
            className={`uppercase transition-opacity duration-300 ${
              activeTab === 'care'
                ? 'opacity-100'
                : 'opacity-50 md:hover:opacity-75'
            }`}
          >
            Care
          </button>
          <button
            className={`uppercase transition-opacity duration-300 md:hover:opacity-75 ${
              activeTab === 'sizing'
                ? 'opacity-100'
                : 'opacity-50 md:hover:opacity-75'
            }`}
            onClick={() => setActiveTab('sizing')}
          >
            Sizing
          </button>
        </div>
        <motion.div
          className="overflow-hidden text-13 leading-120"
          initial={{ height: 'auto' }}
          animate={{ height: height > 0 ? height : 'auto' }}
        >
          <AnimatePresence mode="wait" initial={false}>
            {activeTab === 'detail' ? (
              <motion.div
                key="detail"
                ref={(el) => {
                  setHeight(el?.scrollHeight ?? 0)
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
                className="rich-text"
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
            ) : activeTab === 'sizing' ? (
              <motion.div
                key="sizing"
                ref={(el) => {
                  setHeight(el?.scrollHeight ?? 0)
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {sizing ? sizing : null}
                {openSizing ? (
                  <button
                    onClick={openSizing}
                    className="block pt-14 underline"
                  >
                    Size Guide
                  </button>
                ) : null}
              </motion.div>
            ) : (
              <motion.div
                key="care"
                ref={(el) => {
                  setHeight(el?.scrollHeight ?? 0)
                }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
              >
                {care}
              </motion.div>
            )}
          </AnimatePresence>
        </motion.div>
      </div>
      {sustainability ? (
        <div className="grid grid-cols-2 gap-14 pt-24 text-11  text-midGray">
          {sustainability?.map((detail) => {
            return (
              <div key={detail._key} className="flex items-center gap-8">
                <div className="relative h-[24px] w-[24px] overflow-hidden">
                  <Player
                    autoplay
                    loop
                    src={detail.icon.url}
                    style={{ height: '100%', width: '100%' }}
                  />
                </div>
                {detail.label}
              </div>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}
